import BodyCell from "./BodyCell";
import DataService from "../../../../../../Service";
import { useEffect, useState } from "react";
import useColumnsDataUpdater from "../Hooks/useColumnsDataUpdater";
import { additionalDropdowns } from "../HelperFunctions";

import { getDropdowns } from "../HelperFunctions";

const TableEditRow = ({ row, table }) => {
  const {
    editRowIndex,
    setEditRowIndex,
    updateApiKey,
    setActiveData,
    liveViewType,
    activeData,
  } = table.options.state;

  const [dropdowns, setDropdowns] = useState({});
  const [notFilledMandatoryFields, setNotFilledMandatoryFields] = useState([]);
  const [activeRowData, setActiveRowData] = useState({});
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [noProperInputFields, setNoProperInputFields] = useState([]);

  const {
    isLoading: isMutationLoading,
    isError: isMutationError,
    reset: mutationReset,
    updateRowFunc,
  } = useColumnsDataUpdater({
    setActiveRowData,
    setDisableSubmit,
    setNotFilledMandatoryFields,
    noProperInputFields,
    setNoProperInputFields,
    setEditRowIndex,
    updateApiKey,
    activeRowData,
    notFilledMandatoryFields,
    setActiveData,
    liveViewType,
    activeData,
    columns: table.getAllLeafColumns(),
  });

  // Dropdown fetching logic

  useEffect(() => {
    if (row.id === editRowIndex) {
      getDropdowns(liveViewType, row.original.id)
        .then((response) => {
          setDropdowns(
            {
              ...response,
              ...additionalDropdowns,
            } || {}
          );
        })
        .catch((err) => {});
    }
  }, [editRowIndex]);

  const updateData = (rowIndex, columnId, value) => {
    setActiveRowData((prev) => {
      return { ...prev, [columnId]: value, rowIndex: rowIndex };
    });
  };
  const commonCellProps = {
    table: table,
    row: row,
    rowState: {
      disableSubmit,
      setDisableSubmit,
      activeRowData,
      setActiveRowData,
      notFilledMandatoryFields,
      setNotFilledMandatoryFields,
      dropdowns,
      setDropdowns,
      updateRowFunc,
      isMutationError,
      isMutationLoading,
      mutationReset,
      updateData,
      noProperInputFields,
      setNoProperInputFields,
    },
    tableState: table.options.state,
  };

  return (
    <tr className="live-view-table-row">
      {row.getLeftVisibleCells().map((cell) => {
        return (
          <BodyCell cell={cell} stickPosition="left" {...commonCellProps} />
        );
      })}
      {row.getCenterVisibleCells().map((cell) => {
        return <BodyCell cell={cell} stickPosition="" {...commonCellProps} />;
      })}
      {row.getRightVisibleCells().map((cell) => {
        return (
          <BodyCell cell={cell} stickPosition="right" {...commonCellProps} />
        );
      })}
    </tr>
  );
};
export default TableEditRow;
